module.exports = __webpack_public_path__ + "static/media/supertlv.6cc1895c.jpg";